import React, {useState} from 'react';
import ConstructorNavComponent from "./ConstructorNavComponent/ConstructorNavComponent";
import RedactUserComponent from "./RedactUserComponent/RedactUserComponent";
import RedactGameComponent from "./RedactGameComponent/RedactGameComponent";

const ConstructorComponent = () => {
    const constructorPageList = [
        {page:'game', name:'Опросники'},
        {page:'user', name:'Пользователи'},

    ]
    const [pageConstructor, setPageConstructor] = useState(constructorPageList[0].page)
    switch (pageConstructor){
        case 'user':
            return(<>
                    <ConstructorNavComponent constructorNavList={constructorPageList}
                                             constructorPage={pageConstructor}
                                             setConstructorPage={setPageConstructor}/>
                    <RedactUserComponent />
                </>
            )
        case 'game':
            return(
                <>
                    <ConstructorNavComponent constructorNavList={constructorPageList}
                                         constructorPage={pageConstructor}
                                         setConstructorPage={setPageConstructor}/>
                    <RedactGameComponent/>
                </>
            )

        default:
            return(
                <ConstructorNavComponent constructorNavList={constructorPageList}
                                         constructorPage={pageConstructor}
                                         setConstructorPage={setPageConstructor}/>
            )
    }
};

export default ConstructorComponent;